export default "__VITE_ASSET__CjDPA185__"